import NewWindowIcon from '../assets/footer-new-window.svg';
import XQLogo from '../assets/footer-xq-logo.svg';

import './Footer.css';

const footerLinks = [
  { name: 'Privacy Policy', link: 'https://xqsuperschool.org/privacy-policy', icon: NewWindowIcon },
  { name: 'Terms & conditions', link: 'https://xqsuperschool.org/terms', icon: NewWindowIcon }
];

interface FooterProps {
  classNameProp?: string;
}

function Footer({ classNameProp = '' }: FooterProps) {

  return (
    <footer data-testid="footer" className={`footer ${classNameProp}`}>
      <div className="footer-links-container">
        <img alt="xq footer logo" src={XQLogo} />
        {footerLinks.map(({ name, link, icon }) => (
          <div key={name} className="footer-link-container">
            <a target="_blank" rel="noreferrer" href={link} className="footer-link">{name}</a>
            <img className="icon-size" alt="open in new tab icon" src={icon} />
          </div>
        ))}
      </div>
      <p className="copyright">Copyright © 2024 XQ Institute. All rights reserved.</p>
    </footer>
  );
}

export default Footer;